import api from '../api';

export const deletePropertyImagesService = async (
  imageFileName: string,
): Promise<void> => {
  await api.delete(`/images/properties/${imageFileName}`);
};
